// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"1421b3bc","430":"59ecdfdf","540":"ed912070","548":"0da0e2af","684":"0591cb86","685":"59a924f7","856":"dab39bc9"}[chunkId] + ".chunk.css";
};